import React from 'react';
import { useOutletContext } from 'react-router-dom';
import Reflection from '../../components/Reflection';

export default function ReflectionPage() {
  const ctx = useOutletContext();
  return <Reflection {...ctx} />;
}
